import React from "react";
import Header from "../Header";
import { Paper } from "@mui/material";
import {Button} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";

export default function Help(){

  const navigate = useNavigate()

  return (
    <div className="register-form help">
      <Header />
        <Paper elevation={3} sx={{maxWidth: 620, margin: '0 auto', borderRadius: '1.5em', marginBottom: '2em'}}>
          <div className="help-info">
            <h4 className="form-heading">What is PaperPusher?</h4>
            <p>
              PaperPusher is a tool designed to help artist managers and self-managed musicians 
              reduce the amount of repetitive paper work they need to do when booking live shows.
            </p>
            <h5>Step 1</h5>
            <p>
              An artist or artist manager creates a profile.
            </p>
            <h5>Step 2</h5>
            <p>
              The user populates all information, documents and contract clauses in the user's profile.
            </p>
            <h5>Step 3</h5>
            <p>
              Agreement in principal is reached between the artist and the promoter over email.
            </p>
            <h5>Step 4</h5>
            <p>
              The user creates a new event (in the "Events" section of the admin panel) and enters the basic details 
              already negotiated.
            </p>
            <h5>Step 5</h5>
            <p>
              The user sends the link to <a href="https://paper-pusher.netlify.app/promoter" target="_blank">https://paper-pusher.netlify.app/promoter</a>
               along with the unique event ID generated to the promoter.
            </p>
            <h5>Step 6</h5>
            <p>
              The promoter logs in with the above details and fills in the remaining informations and has immediate access to 
              the artist's performance contract, invoice, riders all other information needed for the event.
            </p>
            <Button onClick={()=> navigate("/")}>Login</Button>
            <Button onClick={()=> navigate("/register")}>Register</Button>
          </div>
        </Paper>
      
    </div>
  )
}